var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlexivox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 170,
    viewBox: "0 0 171 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_1390)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_640_1390)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.6621,
    y: 41.0471,
    width: 62.3174,
    height: 101.621,
    rx: 11,
    fill: "white",
    stroke: "#E87663",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.458 54.0071C70.458 52.9025 71.3534 52.0071 72.458 52.0071H113.7C114.804 52.0071 115.7 52.9025 115.7 54.0071V117.091C115.7 118.196 114.804 119.091 113.7 119.091H72.458C71.3534 119.091 70.458 118.196 70.458 117.091V54.0071Z",
    fill: "#F9C8BA",
    stroke: "#E87663",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.2131,
    cy: 130.626,
    r: 3.1965,
    stroke: "#E87663",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1158 74.9064L86.9565 68.502L86.9556 68.5006C85.8728 66.8392 83.6513 66.3704 81.9877 67.4456L81.9845 67.4477C80.3242 68.5299 79.8517 70.7505 80.9318 72.415L80.9321 72.4154L87.8837 83.1145L88.0183 83.3217L88.234 83.4424L89.3986 84.094C87.722 83.47 85.6075 83.0031 83.5475 83.3516L83.5469 83.3517C81.0474 83.7759 78.7509 84.9977 77.0473 86.885L48.7149 58.1758C48.3588 57.8003 47.8902 57.5567 47.4094 57.4791C46.9313 57.4019 46.3289 57.4791 45.8653 57.9165L91.1158 74.9064ZM91.1158 74.9064L89.8764 71.3911L89.8762 71.3906C89.2589 69.6365 90.1796 67.7167 91.9322 67.0971L91.9362 67.0957C93.6853 66.4857 95.6073 67.4 96.2244 69.1534L98.7093 76.2009M91.1158 74.9064L98.7093 76.2009M98.7093 76.2009C99.3027 75.4131 100.246 74.9033 101.309 74.9033C103.108 74.9033 104.562 76.3614 104.562 78.1563V117.77V118.77H103.562H90.0457H89.0457V117.77V111.028L79.3459 103.949C77.4215 102.619 74.7018 99.6729 74.3201 96.0307C74.1874 94.7668 74.6817 93.5257 75.6288 92.7543L45.9442 60.8324C45.9438 60.8321 45.9435 60.8317 45.9432 60.8313C45.559 60.4197 45.3711 59.8941 45.3376 59.4151C45.3062 58.9651 45.4037 58.3519 45.8649 57.9168L98.7093 76.2009ZM81.4267 91.1817L82.2019 91.8134C82.8268 91.0466 83.7022 90.5408 84.6768 90.3865L84.679 90.3861C85.7361 90.2164 86.784 90.4665 87.6511 91.0959C88.516 91.7247 89.0852 92.6495 89.2529 93.7001C89.5995 95.8744 88.1122 97.9269 85.937 98.2763L85.9363 98.2764C85.4041 98.3623 84.8773 98.3338 84.3794 98.2084C84.6271 97.9589 84.9201 97.612 85.0996 97.2104C85.2874 96.7901 85.3797 96.2747 85.2342 95.7067C85.0943 95.1605 84.7593 94.6625 84.2727 94.2063L82.0659 91.9712C82.1132 91.9196 82.1593 91.8661 82.2041 91.8107L81.4267 91.1817ZM81.4267 91.1817C81.4055 91.2078 81.384 91.2334 81.362 91.2583L84.5204 89.3988C83.301 89.5918 82.2059 90.2255 81.4267 91.1817ZM83.3546 97.7915C83.3653 97.782 83.3763 97.7723 83.3876 97.7623C83.924 97.2881 85.0495 96.2929 83.5754 94.9234L83.3546 97.7915Z",
    fill: "white",
    stroke: "#E87663",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_1390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    fill: "white",
    transform: "translate(0.525391)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_640_1390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.173,
    height: 119.337,
    fill: "white",
    transform: "translate(29.9385 25.3315)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexivox);
export default __webpack_public_path__ + "static/media/flexivox.e6c973df4cc9b0cbc0309cb2c4ab4150.svg";
export { ForwardRef as ReactComponent };